import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-portfolio-list',
  templateUrl: './portfolio-list.component.html',
  styleUrls: ['./portfolio-list.component.scss']
})
export class PortfolioComponent implements OnInit {

  constructor(
    private titleService: Title,
    private meta: Meta,
  ) { }

  portFolioList = [
    // {
    //   id: 10,
    //   name: 'Sarva Shiksha Abhiyan',
    //   image: 'sass.png',
    //   link: 'javascript:void(0)'
    // },
    // {
    //   id: 1,
    //   name: 'Foreign Foods',
    //   image: 'foreignfoods.png',
    //   link: 'https://foreignfoods.in/'
    // },
    {
      id: 2,
      name: 'Taj Park',
      image: 'Tajpark.png',
      link: 'https://tajpark.ca/'
    },
    {
      id: 3,
      name: 'Milan Group Of India',
      image: 'Milan.png',
      link: 'https://milangroupindia.com/'
    },
    {
      id: 4,
      name: 'Rreza Enterprise',
      image: 'Rezaenterprise.png',
      link: 'https://www.reza-enterprise.com/'
    },
    {
      id: 5,
      name: 'Avis Developers',
      image: 'AvisDevelopers.png',
      link: 'https://avisdevelopers.com/'
    },
    {
      id: 6,
      name: 'Zahra Enterprise',
      image: 'ZahraEnterprise.png',
      link: 'https://zahraenterprise.kaimsit.com/'
    },
    {
      id: 7,
      name: 'Sohi Vacations',
      image: 'SohiVacations.png',
      link: 'https://sohivacations.com/'
    },
    {
      id: 8,
      name: 'Vakil Exports',
      image: 'VakilExports.png',
      link: 'http://vakilexports.com/'
    },
    {
      id: 9,
      name: 'Maariya Impex',
      image: 'MaariyaImpex.png',
      link: 'https://maariyaimpex.com/'
    }
  ]

  ngOnInit() {
    this.titleService.setTitle('Kaims IT Services | Custom Software Development | ERP Development | Website Development Company in Ahmedabad - India');
    this.meta.updateTag({ name: "description", content: 'Partner with Kaims IT Services for your ERP, CRM, Application Management and Cloud Solutions needs by hiring our CRM and .NET Experts in India' });
    this.meta.updateTag({ name: "keywords", content: 'Web Development Company India, Mobile App Development Company India and India, ERP and CRM Service Provider, Kaims IT Services' });
    this.meta.updateTag({ name: "author", content: 'Kaims IT Services' });
  }

}
